import { h } from 'vue';
import { ElNotification } from 'element-plus';

/**
 * Notificación de error para los mensajes del registro de errores (`use_error_registry.js`).
 * `ElNotification` no respeta saltos de línea en un `message` de tipo string — un
 * `mensajes.join('\n')` se renderiza como un único párrafo corrido, ilegible apenas hay más
 * de un mensaje. Acá se arma una lista (un ítem por mensaje) para que cada uno quede en su
 * propia línea, visualmente separado del resto.
 *
 * @param {string[]} mensajes
 */
export function notificarErroresValidacion(mensajes) {
  const lista = mensajes.length ? mensajes : ['Revise las advertencias en pantalla.'];
  ElNotification({
    title: 'Datos no válidos',
    type: 'error',
    message: h(
      'ul',
      { class: 'notificacion-errores-validacion' },
      lista.map((mensaje) => h('li', mensaje)),
    ),
  });
}
